export const enum CellStyles {
  GREY = 'grey',
  NOWRAP = 'nowrap',
  HIDEPRELOGON = 'hideprelogon'
}

export type CellStyle = `${CellStyles}`;

export const cellStyleClasses: Map<string, string> = new Map([
  [CellStyles.GREY, 'sd-meta--light'],
  [CellStyles.NOWRAP, 'no-wrap'],
  [CellStyles.HIDEPRELOGON, 'hide-prelogon']
]);
